import React, { Fragment } from 'react';

import {
  formInput,
  formCheckbox,
  formRadio,
  formTextarea,
  formDate,
  formFile,
} from '../components/FormFields';

const roleCheck = (inPresetRoles = []) => {
  return (toCheckRoleNames = []) => {
    return toCheckRoleNames.some((role) => inPresetRoles.includes(role));
  }
}

export default {
  sections: {
    roles: {
      label: 'I am applying for (check all that apply)',
      fields: [{
        func: formCheckbox,
        key: 'roles',
        label: 'Role',
        required: true,
        options: [{
          value: 'counselor',
          label: 'Counselor',
        }, {
          value: 'reporter',
          label: 'Reporter',
        }, {
          value: 'guardian',
          label: 'Guardian',
        }, {
          value: 'teacher',
          label: 'Teacher',
        }, {
          value: 'nurse',
          label: 'Nurse',
        }, {
          value: 'administator',
          label: 'Administrator',
        }, {
          value: 'other',
          label: 'Other',
        }],
      }]
    },
    general: {
      label: 'General Information',
      fields: [{
        func: formInput,
        key: 'email',
        label: 'Email',
        required: true,
        md: 12,
      }, {
        func: formInput,
        key: 'firstName',
        label: 'First Name',
        required: true,
        md: 6,
      }, {
        func: formInput,
        key: 'lastName',
        label: 'Last Name',
        required: true,
        md: 6,
      }, {
        func: formInput,
        key: 'chineseName',
        label: 'Chinese Name',
        required: false,
        md: 6,
      }, {
        func: formInput,
        key: 'aka',
        label: 'A.K.A',
        required: false,
        md: 6,
      }, {
        func: formInput,
        key: 'phoneNumber',
        label: 'Phone Number',
        required: true,
      }, {
        func: formDate,
        key: 'birthday',
        label: 'Date of Birth',
        required: true,
      }, {
        func: formRadio,
        key: 'gender',
        label: 'Gender',
        required: true,
        options: [{ value: 'male', label: 'Male' }, { value: 'female', label: 'Female' }],
      }, {
        func: formRadio,
        key: 'isVerizon',
        label: 'I have Verizon Wireless Cell Phone Service',
        required: true,
        options: [{ value: 'yes', label: 'Yes' }, { value: 'no', label: 'No' }],
      }, {
        func: formRadio,
        key: 'facebookShareDaily',
        label: 'I have devices to take photos or videos, AND I am willing to post my Team’s daily activities on Facebook daily.',
        required: true,
        options: [{ value: 'yes', label: 'Yes' }, { value: 'no', label: 'No' }],
      }, {
        func: formCheckbox,
        key: 'tshirtSize',
        label: 'T-shirtSize',
        required: true,
        options: [
          { value: 'adult-S', label: 'Adult S' },
          { value: 'adult-M', label: 'Adult M' },
          { value: 'adult-L', label: 'Adult L' }
        ],
      }, {
        func: formFile,
        key: 'driverLicense',
        label: 'Upload Driver License',
        required: true,
        md: 12,
      }, {
        func: formFile,
        key: 'photo',
        label: 'B/W or Color photo for program book',
        required: true,
        md: 12,
      }]
    },
    address: {
      label: 'Home Address',
      fields: [{
        func: formInput,
        key: 'address.street',
        label: 'Street',
        required: true,
      }, {
        func: formInput,
        key: 'address.city',
        label: 'City',
        required: true,
        md: 4,
      }, {
        func: formInput,
        key: 'address.state',
        label: 'State',
        required: true,
        md: 4,
      }, {
        func: formInput,
        key: 'address.zipCode',
        label: 'Zip Code',
        required: true,
        md: 4,
      }]
    },
    programBook: {
      label: 'Type a paragraph(4-5 sentences ) of what you would like to appear in our Program Book: where you go to school, work, education, background, hobbies, etc.',
      fields: [{
        func: formTextarea,
        guide: 'Please write in English AND Chinese for our program book',
        key: 'programBookDescription',
        label: 'Type here...',
        required: true,
      }]
    },
    criminalHistory: {
      label: 'Criminal History',
      fields: [{
        func: formRadio,
        key: 'criminalHistory',
        label: 'Have you ever been arrested, convicted of a felony crime, or served time in jail?',
        required: true,
        options: [{ value: 'no', label: 'No' }, { value: 'yes', label: 'Yes' }, ],
      }, {
        func: formInput,
        key: 'criminalHistoryExplanation',
        label: 'If yes, please explain',
        required: false,
      }]
    },
    experience: {
      label: 'Summercamp Experience',
      fields: [{
        func: formInput,
        key: 'attendYears',
        label: 'I have attended summercamp in years',
        required: false,
      }, {
        func: formInput,
        key: 'servedAsReporterYears',
        label: 'I have served as Reporter in years',
        required: false,
      }, {
        func: formInput,
        key: 'servedAsCounselorYears',
        label: 'I have served as Counselor in years',
        required: false,
      }, {
        func: formInput,
        key: 'servedAsGuardianYears',
        label: 'I have served as Guardian in years',
        required: false,
      }, {
        func: formInput,
        key: 'servedAsTeacherYears',
        label: 'I have served as Teacher in years',
        required: false,
      }, {
        func: formInput,
        key: 'servedAsNurseYears',
        label: 'I have served as Nurse in years',
        required: false,
      }]
    },
    reference: {
      label: 'Reference',
      fields: [{
        func: formInput,
        key: 'reference.name',
        label: 'Reference Name (who referred you?)',
        required: true,
      }, {
        func: formInput,
        key: 'reference.phoneNumber',
        label: 'Reference Cell Phone',
        required: false,
      }, {
        func: formInput,
        key: 'reference.relationship',
        label: 'Reference Title/Relationship',
        required: true,
      }]
    },
    emergencyPrimary: {
      label: 'Emergency Contact (primary)',
      fields: [{
        func: formInput,
        key: 'emergency.primary.firstName',
        label: 'First Name',
        md: 6,
        required: true,
      }, {
        func: formInput,
        key: 'emergency.primary.lastName',
        label: 'Last Name',
        md: 6,
        required: true,
      }, {
        func: formInput,
        key: 'emergency.primary.relationship',
        label: 'Relationship',
        md: 6,
        required: true,
      }, {
        func: formInput,
        key: 'emergency.primary.chineseName',
        label: 'Chinese Name',
        md: 6,
        required: false,
      }, {
        func: formInput,
        key: 'emergency.primary.phoneNumber',
        label: 'Phone Number',
        required: true,
      }, {
        func: formInput,
        key: 'emergency.primary.email',
        label: 'Email',
        required: true,
      }]
    },
    emergencySecondary: {
      label: 'Emergency Contact (secondary)',
      fields: [{
        func: formInput,
        key: 'emergency.secondary.firstName',
        label: 'First Name',
        md: 6,
        required: true,
      }, {
        func: formInput,
        key: 'emergency.secondary.lastName',
        label: 'Last Name',
        md: 6,
        required: true,
      }, {
        func: formInput,
        key: 'emergency.secondary.relationship',
        label: 'Relationship',
        md: 6,
        required: true,
      }, {
        func: formInput,
        key: 'emergency.secondary.chineseName',
        label: 'Chinese Name',
        md: 6,
        required: false,
      }, {
        func: formInput,
        key: 'emergency.secondary.phoneNumber',
        label: 'Phone Number',
        required: true,
      }, {
        func: formInput,
        key: 'emergency.secondary.email',
        label: 'Email',
        required: true,
      }]
    },
    language: {
      label: 'Comprehension of Languages',
      fields: [{
        func: formCheckbox,
        key: 'language.chinese',
        label: 'Chinese',
        required: false,
        options: [
          { value: 'listen', label: 'Listen' },
          { value: 'speak', label: 'Speak' },
          { value: 'read', label: 'Read' },
          { value: 'write', label: 'Write' },
        ]
      }, {
        func: formCheckbox,
        key: 'language.english',
        label: 'English',
        required: false,
        options: [
          { value: 'listen', label: 'Listen' },
          { value: 'speak', label: 'Speak' },
          { value: 'read', label: 'Read' },
          { value: 'write', label: 'Write' },
        ]
      }, ]
    },
    // recommendation: {
    //   label: 'Recommendation',
    //   description: 'If you are in high school, please attach two recommendation letters from your current school year Teachers and/or School Counselor.',
    //   condition: roleCheck(['counselor', 'reporter']),
    //   fields: [{
    //     func: formFile,
    //     key: 'recommendations',
    //     label: 'Recommendation Documents',
    //     required: true,
    //   }],
    // },
    reporter: {
      label: 'Reporter',
      condition: roleCheck(['reporter']),
      fields: [{
        //   func: formRadio,
        //   key: 'reporter.attendAsCamperIfNotChosen',
        //   label: 'In the event we have more qualified Counselor or Reporter applications than we need, and you are not chosen for the position applied, do you still wish to attend the summer camp as a Camper?',
        //   required: true,
        //   options: [{ value: 'yes', label: 'Yes' }, { value: 'no', label: 'No' }],
        // }, {
        func: formInput,
        key: 'school.name',
        label: 'School Name',
        required: true,
      }, {
        func: formInput,
        key: 'school.grade',
        label: 'School Grade',
        required: true,
        md: 6,
      }, {
        func: formInput,
        key: 'school.gpa',
        label: 'School GPA',
        required: true,
        md: 6,
      }, {
        func: formInput,
        key: 'chineseSchoolName',
        label: 'Chinese School Name',
        required: true,
      }]
    },
    counselor: {
      label: 'Counselor',
      condition: roleCheck(['counselor']),
      fields: [{
        //   func: formRadio,
        //   key: 'counselor.attendAsCamperIfNotChosen',
        //   label: 'In the event we have more qualified Counselor or Reporter applications than we need, and you are not chosen for the position applied, do you still wish to attend the summer camp as a Camper?',
        //   required: true,
        //   options: [{ value: 'yes', label: 'Yes' }, { value: 'no', label: 'No' }],
        // }, {
        func: formInput,
        key: 'school.name',
        label: 'School Name',
        required: true,
      }, {
        func: formInput,
        key: 'school.grage',
        label: 'School Grade',
        required: true,
        md: 6,
      }, {
        func: formInput,
        key: 'school.gpa',
        label: 'School GPA',
        required: true,
        md: 6,
      }, {
        func: formInput,
        key: 'chineseSchoolName',
        label: 'Chinese School Name',
        required: true,
      }]
    },
    guardian: {
      label: 'Guardian',
      condition: roleCheck(['guardian']),
      description: `We DO NOT recommend that your be the Guardian for your child's team, AND we may have more parents volunteering to be Guardians for certain teams, so we DO NOT guarantee that you will be placed with your child's team.`,
      fields: [{
        func: formRadio,
        key: 'guardian.hasChildrenAttend',
        label: 'I have child(ren) also attending summer camp',
        required: true,
        options: [{ value: 'yes', label: 'Yes' }, { value: 'no', label: 'No' }],
      }, {
        func: formInput,
        key: 'guardian.hasChildrenAttendListNames',
        label: `Please list child(ren) name and Age if applied.`,
        required: false,
      }, {
        func: formInput,
        key: 'guardian.canStayForAll',
        label: `I am able to stay for the entire 8 days / 7 nights`,
        required: true,
        options: [{ value: 'yes', label: 'Yes' }, { value: 'no', label: 'No' }],
      }]
    },
    teacher: {
      label: 'Teacher',
      condition: roleCheck(['teacher']),
      description: `
        We will be publishing the Classes and Bios of each teacher in our Summer Camp program book.
        Please list ALL Topics & brief description (in Chinese or English) of all classes you are able & willing to teach, so we can schedule our classes accordingly.
        
        Please submit any sample slides or print-outs for review SummerCamp.SCCCS@gmail.com.
        Please bring all your own teaching materials/art supplies. Please let us know ahead of time if you need.
      `,
      fields: [{
        func: formRadio,
        key: 'teacher.hasChildrenAttend',
        label: 'I have child(ren) also attending summer camp',
        required: true,
        options: [{ value: 'yes', label: 'Yes' }, { value: 'no', label: 'No' }],
      }, {
        func: formInput,
        key: 'teacher.hasChildrenAttendListNames',
        label: `Please list child(ren) name and Age.`,
        required: true,
      }, {
        func: formCheckbox,
        key: 'teacher.availableSpots',
        label: 'I am available to teach (choose one)',
        required: true,
        options: [
          { value: 'A', label: 'Sun  6/30. – Tues. 7/3  (3 days) – need to provide own transportation.' },
          { value: 'B', label: 'Wed. 7/3 – Fri. 7/5  (3 days) – need to provide own transportation; you may also ride back with us on Sat. 7/6 (one way).' },
          { value: 'C', label: 'Sat. 6/29  – Sat. 7/6  (8 days ) - will be transported via Chartered buses with students' },
        ],
      }, {
        func: formTextarea,
        key: 'teacher.subjects',
        label: 'Please list ALL Topics & brief description (in Chinese or English) of all classes you are able & willing to teach',
        required: true,
      }, {
        func: formTextarea,
        key: 'teacher.previousSubjects',
        label: 'Subject(s) that I taught in previous summer camps were',
        required: true,
      }, {
        func: formInput,
        key: 'teacher.reimbursement',
        label: 'Reimbursement for your teaching materials/supplies amount requested $__?',
        required: true,
      }, {
        func: formTextarea,
        key: 'teacher.specialRequests',
        label: 'Do you need special equipment or supplies (i.e. projector, craft paper, scissors...)',
        required: true,
      }, {
        func: formRadio,
        key: 'teacher.isTeachingNow',
        label: 'Are you currently teaching?',
        required: true,
        options: [{ value: 'yes', label: 'Yes' }, { value: 'no', label: 'No' }],
      }, {
        func: formInput,
        key: 'school.name',
        label: 'Current Teaching School Name',
        required: true,
      }, {
        func: formInput,
        key: 'school.principal',
        label: 'Name of Principal/Administrator',
        required: true,
      }, {
        func: formInput,
        key: 'school.principalPhoneNumber',
        label: 'Phone Number or Principal/Administrator',
        required: true,
      }, {
        func: formTextarea,
        key: 'school.taughtProjects',
        label: 'Please list below with other schools and projects that you have taught before.',
        required: true,
      }]
    },

    waiverEmergency: {
      label: 'Waiver - Authorization for Emergency / Medical Care and Claim Waiver',
      description() {
        return (<Fragment>
          <p>
            I would like to participate in the Chinese Cultural Youth Summer Camp sponsored by the Southern California Council of Chinese Schools (SCCCS).
          </p>
          <p>
            I am in excellent physical condition. I do not smoke or have other bad habits. Should I become ill or injured at the camp, I may receive necessary first aid or medical attention by a licensed physician or nurse, or be admitted to a hospital in case of an emergency. This authorization is given pursuant to Section 25.8 of Civil Code of California and remains effective only for the event and time period specified above.
          </p>
          <p>
            I will not hold YMCA Camp Oakes, SCCCS or its officers, teachers, and helpers liable for the above activity and medical aid rendered. I understand this activity is voluntary and I desire to participate in it. I also understand that there are certain risks involved in this activity, including, but not limited to, accidents, injuries, illness or death while traveling to and from said activity, and/or in the course of the activity, and/or the potential for property damage and/or loss. I will reimburse SCCCS for medical or other expenses incurred for  my care.
          </p>
          <p>
          茲聲明本表所填各項屬實，本人身心健康，無不良素行，亦不抽煙，自願申請擔任貴會夏令營監護人，如獲聘任
          ，將準時參加8hrs的營前講習，我了解將不會被派任為自己孩子營隊的監護人，活動期間將以認真負責、公平合理與
          親切和藹的態度協助輔導員照顧學員，並與貴會工作人員合作，遵守相關規定，讓學員有個快樂安全的夏令營。
          </p>
          </Fragment>)
      },
      fields: [{
        func: formFile,
        key: 'waiverEmergencyInsuranceCardLink',
        label: `Upload COPY OF VALID INSURANCE CARD.`,
        required: true,
      }, {
        func: formInput,
        key: 'waiverEmergencySpecialRequest',
        label: `Do you have any special request regarding your health condition?`,
        required: false,
      }, {
        func: formInput,
        key: 'waiverEmergencySignature',
        guide: `E-  Signature- By typing my name below, I certify that I am over the Age of 18.  If I am under 18, then my Parent/Guardian will also type his/her name here as agreeing to all the terms, conditions, and rules.`,
        label: 'Sign Here',
        required: true,
      }]
    },

    waiverPhotoRelease: {
      label: 'Waiver - PHOTOGRAPHY RELEASE',
      description() {
        return (<Fragment>
          <p>
            I/We hereby authorize SCCCS Chinese Cultural Youth Summer Camp officials, hereafter referred to as “SCCCS” to the right to take photographs of me
            and my family in connection with SCCCS activities. I authorize SCCCS, its assigns and transferees to
            copyright, use and publish the same in print and/or electronically for any lawful purpose. I hereby release and
            hold harmless SCCCS from any reasonable expectation of privacy or confidentiality for myself and for the
            minor child and children listed below associated with the images specified above. Further, I attest that I am the
            parent or legal guardian of the child or children listed below and that I have full authority to consent and
            authorize SCCCS to use their likenesses and names including social medias.
          </p>
          <p>
            We further acknowledge that participation is voluntary and that neither I, the minor child, or minor children will
            receive financial compensation of any type associated with the taking or the publishing of these photographs. I
            acknowledge and agree that publication of said photos confers no rights of ownership or royalties whatsoever. I
            hereby release SCCCS, its contractors, its volunteers and any third parties involved in taking or publishing
            photographs, from liability for any claims by me or any third party in connection with my participation or the
            participation of the minor children listed below.
          </p>
          </Fragment>)
      },
      fields: [{
        func: formInput,
        key: 'waiverPhotoReleaseSignature',
        guide: `E-  Signature- By typing my name below, I certify that I am over the Age of 18.  If I am under 18, then my Parent/Guardian will also type his/her name here as agreeing to all the terms, conditions, and rules.`,
        label: 'Sign Here',
        required: true,
      }]
    },

    waiverYMCA: {
      label: 'YMCA OF GREATER LONG BEACH RELEASE AND WAIVER OF LIABILITY AND INDEMNITY AGREEMENT AND INDEMNITY AGREEMENT',
      description() {
        return (<Fragment>
          <p>
              IN CONSIDERATION of being permitted to utilize the facilities, services and programs of the YMCA (or for my children to so participate)
              for any purpose, including, but not limited to observation or use of facilities, equipment , or participation in any off-site program affiliated
              with the YMCA, the undersigned, for himself or herself and such participating children and any personal representatives, heirs, and next of kin,
              hereby acknowledges, agrees and represents that he or she has, or immediately upon entering or participating will, inspect and carefully consider 
              such premises and facilities or the affiliated program. It is further warranted that such entry into the YMCA for observation or use of any 
              facilities or equipment or participation in such affiliated program constitutes an acknowledgement that such premises and all facilities and 
              equipment thereon and such affiliated program have been inspected and carefully considered and that the undersigned finds and accepts same as 
              being safe and reasonably suited for the purpose of such observation, use or participation by the undersigned and such children.
          </p>
          <p>
              IN FURTHER CONSIDERATION OF BEING PERMITTED TO ENTER THE YMCA FOR ANY PURPOSE INCLUDING, BUT NOT LIMITED TO OBSERVATION OR USE OF FACILITIES
              OR EQUIPMENT, OR PARTICIPATION IN ANY OFF-SITE PROGRAM AFFILIATE D WITH THE YMCA, THE UNDER SIGNED HEREBY AGREES TO THE FOLLOWING:
          </p>
          <ol>
              <li>
                  THE UNDERSIGNED, ON HIS OR HER BEHALF AND BEHALF OF SUCH CHILDREN, HER BY RELEASES, W AIVES, DISCHARGES AND COVENANTS NOT TO SUE the YMCA,
                  and/or branch affiliates, its directors, officers, employees, and agents (hereinafter referred to as "releasees") from all liability to the 
                  undersigned or such children and all his personal representatives, assigns, heirs, and next of kin for any loss or damage, and any claim or 
                  demands therefor on account of injury to the person or property or resulting in death of the undersigned or such children whether caused by 
                  the negligence of the releasees or otherwise while the undersigned or such children is in, upon, or about the premises or any facilities or 
                  equipment therein or participating in an y program affiliated with the YM CA.
              </li>
              <li>
                  THE UNDERSIGNED HEREBY AGREES TO INDEMNIFY AND SAVE AND HOLDHARMLES S the releasees and each of them from any loss, liability, damage 
                  or cost they may incur due to the presence of the undersigned of such children in, upon or about the YMCA premises or in any way observing 
                  or using any facilities or equipment of the YMCA or participating in any prog ram affiliated with the YMCA whether caused by negligence of 
                  the releasees or otherwise. 
              </li>
              <li>
                  THE UNDERSIGNED HEREBY ASSUMES FULL RESPONSIBILITY FOR AND RISK OF BODILY INJURY, DEATH OR PROPERTY DAMAGE to the undersigned or such children 
                  due to negligence of releasee or otherwise while in, about or upon the premises of the YMCA and/or while using the premises or any facilities 
                  or equipment thereon or participating in any program affiliated with the YMCA. 
              </li>
          </ol>

          <p>
              Rifle Range <br/>
              Safety and supervision is the Y’s number one priority. If you agree to allow your child to participate, please initial below. California Penal 
              Code Section 12552 prohibits furnishing firearms to minors without the express or implied per mission of the parent/guardian of the minor. 
              Understanding this, I give my permission for my child to use a firearm at Camp Oakes. 
          </p>

          <p>
              THE UNDERSIGNED further expressly agrees that the foregoing RELEASE, WAIVER AND INDEMNITY AGREEMENT is intended to be as broad and inclusive as 
              is permitted by the law of the State of California and that if any portion thereof is held invalid, it is agreed that the balance shall, 
              notwithstanding, continue in full legal force and effect. <br/>

              THE UNDERSIGNED HAS READ & VOLUNTARILY SIGNS THE RELEASE AND WAIVER OF LIABILITY AND INDEMNITY AGREEMENT, and further agrees that no oral 
              representations,  statements of inducement apart from the foregoing written agreement have been made.
          </p>

          <p>
              I give permission for the YMCA to use any pictures taken for future promotion purposes <br/><br/>
          </p>
        </Fragment>)
      },
      fields: [{
        func: formInput,
        key: 'waiverYMCASignature',
        guide: `E-  Signature- By typing my name below, I certify that I am over the Age of 18.  If I am under 18, then my Parent/Guardian will also type his/her name here as agreeing to all the terms, conditions, and rules.`,
        label: 'Sign Here',
        required: true,
      }]
    }
  },
};
